import { render, staticRenderFns } from "./StoreTransferStatusChip.vue?vue&type=template&id=6eca5301&scoped=true"
import script from "./StoreTransferStatusChip.vue?vue&type=script&lang=js"
export * from "./StoreTransferStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eca5301",
  null
  
)

export default component.exports